import { render, staticRenderFns } from "./SaveGraphComponent.vue?vue&type=template&id=2b71b1cf&scoped=true&"
import script from "./SaveGraphComponent.vue?vue&type=script&lang=js&"
export * from "./SaveGraphComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71b1cf",
  null
  
)

export default component.exports